module.exports = __webpack_public_path__ + "img/offline-white.a69cf36c.svg";